import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
var _valueToText;
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React, { useCallback, useMemo } from "react";
import { useFormikContext } from "formik";
import { PillBadge } from "@xo-union/tk-component-badges";
import BlankButton from "@xo-union/component-blank-button";
import styles from "./styles.css";
import { DatePreference } from "./types.js";
var SEASON = DatePreference.Season;
var EXACT = DatePreference.Exact;
var RANGE = DatePreference.Range;
var TBA = DatePreference.Tba;
var NONE = DatePreference.None;
var DEFAULT_PILLS = [SEASON, EXACT, RANGE, TBA];
var valueToText = (_valueToText = {}, _defineProperty(_valueToText, SEASON, 'Season & Year'), _defineProperty(_valueToText, EXACT, 'Exact Date'), _defineProperty(_valueToText, RANGE, 'Multi Date'), _defineProperty(_valueToText, TBA, 'Not Sure'), _defineProperty(_valueToText, NONE, ''), _valueToText);
export var DatePrefPillGroup = function DatePrefPillGroup(_ref) {
  var currentView = _ref.currentView,
    onClick = _ref.onClick,
    config = _ref.config;
  var _useFormikContext = useFormikContext(),
    setValues = _useFormikContext.setValues,
    values = _valuesInstanceProperty(_useFormikContext);
  var formValues = useMemo(function () {
    return values;
  }, [values]);
  var onPillClick = useCallback(function (value) {
    if (currentView !== value) {
      var formatValue = formValues === null || formValues === void 0 ? void 0 : formValues.format;
      if (value === EXACT) formatValue = 'natural';
      if (value === RANGE) formatValue = 'range';
      // set hideDate for select/deselect Not Sure Yet
      setValues(_objectSpread(_objectSpread({}, formValues), {}, {
        format: formatValue,
        hideDate: value === TBA,
        preference: value
      }));
      onClick(value);
    }
  }, [currentView, formValues, onClick, setValues]);
  var pillClassName = React.useCallback(function (value) {
    var className = "".concat(styles.pills);
    if (value === currentView) className += " ".concat(styles.activePill);
    return className;
  }, [currentView]);
  var pills = React.useMemo(function () {
    var p = DEFAULT_PILLS;
    if (!config.showTBA) {
      p = _filterInstanceProperty(p).call(p, function (pill) {
        return pill !== TBA;
      });
    }
    return p;
  }, [config]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.pillGroup
  }, _mapInstanceProperty(pills).call(pills, function (p) {
    return /*#__PURE__*/React.createElement(BlankButton, {
      key: p,
      "data-testid": "pill-".concat(valueToText[p].toLowerCase().replace(/\s/g, '-')),
      onClick: function onClick(e) {
        e.preventDefault();
        onPillClick(p);
      }
    }, /*#__PURE__*/React.createElement(PillBadge, {
      className: pillClassName(p)
    }, valueToText[p]));
  }));
};